/* global flowplayer:writable */
import log        from './debug'
import { isIOS }  from './util'

var ANDROID_JS_API = "Controls_JS_API"

var PlayerEvents = {
  IDLE:               "idle",
  LOADING:            "loading",
  PREPARED:           "prepared",
  BUFFERING:          "buffering",
  PLAYING:            "playing",
  PAUSED:             "paused",
  DURATION:           "duration",        // seconds: float
  PROGRESS:           "progress",        // seconds: float
  COMPLETED:          "completed",
  ERROR:              "error",           // code: int, message: string
  FULLSCREEN:         "fullscreen",      // state: bool
  MUTED:              "muted",           // muted: bool
  VOLUME:             "volume",          // volume: float
  PLAYBACK_RATE:      "playbackRate",    // rate: float
  QUALITIES:          "qualities",       // qualities: array<{ level, width, height, text (optional) }>
  SET_QUALITY:        "setQuality",      // level: int
  AUDIO_TRACKS:       "audioTracks",     // tracks: array<{ id, name, lang }>
  SUBTITLE_TRACKS:    "subtitleTracks",  // tracks: array<{ id, name, lang }>
  OVP_METADATA:       "ovpMetadata",     // metadata: object
  SET_AUDIO:          "setAudio",        // track: object
  SET_SUBTITLE:       "setSubtitle",     // track: int
  CAST_STATE_CHANGED: "castStateChanged" // state: bool
}

var PlayerApi = {
  PLAY:           "play",
  PAUSE:          "pause",
  SEEK:           "currentTime",    // position: float
  MUTE:           "mute",           // mute: bool
  VOLUME:         "volume",         // volume: float
  PLAYBACK_RATE:  "playbackRate",   // rate: float
  FULLSCREEN:     "fullscreen",     // state: bool
  READY:          "ready",
  ERROR:          "error",          // error: string
  RELOAD:         "reload",
  SET_QUALITY:    "setQuality",     // level: int
  SET_AUDIO:      "setAudio",       // track: id
  SET_SUBTITLE:   "setSubtitle",    // track: id
}

var player_ready = false

export function play() {
  player.paused = false
  return send_web_view_event(PlayerApi.PLAY)
}

export function pause() {
  player.paused = true
  return send_web_view_event(PlayerApi.PAUSE)
}

export function set_current_time(value) {
  if (send_web_view_event(PlayerApi.SEEK, value)) {
    player.emit(flowplayer.events.SEEKED)
    return true
  }
  return false
}

export function set_muted(muted) {
  if (!player_ready) return
  return send_web_view_event(PlayerApi.MUTE, muted)
}

export function set_volume(value) {
  if (!player_ready) return
  var volume = value.toFixed(2)
  return send_web_view_event(PlayerApi.VOLUME, volume)
}

export function set_playback_rate(value) {
  var rate = value.toFixed(2)
  return send_web_view_event(PlayerApi.PLAYBACK_RATE, rate)
}

export function set_fullscreen(fullscreen) {
  if (!player_ready) return
  return send_web_view_event(PlayerApi.FULLSCREEN, fullscreen)
}

export function set_quality(level) {
  return send_web_view_event(PlayerApi.SET_QUALITY, level)
}

export function set_audio(id) {
  return send_web_view_event(PlayerApi.SET_AUDIO, id)
}

export function set_subtitle(id) {
  return send_web_view_event(PlayerApi.SET_SUBTITLE, id)
}

export function notify_ready() {
  player_ready = true
  return send_web_view_event(PlayerApi.READY)
}

export function notify_error(error) {
  return send_web_view_event(PlayerApi.ERROR, error)
}

export function reload() {
  return send_web_view_event(PlayerApi.RELOAD)
}

function send_web_view_event(event, param1, param2, param3) {
  log("send_web_view_event:", event, param1, param2, param3)
  
  var handled = false;
  if (typeof param1 === "undefined") param1 = ""
  if (typeof param2 === "undefined") param2 = ""
  if (typeof param3 === "undefined") param3 = ""
  
  if (isIOS()) {
    var url = "flowplayer://onControlEvent?event=" + event
      + "&arg1=" + encodeURIComponent(param1)
      + "&arg2=" + encodeURIComponent(param2) +
      "&arg3=" + encodeURIComponent(param3)
    var iframe = document.createElement("IFRAME")
    iframe.setAttribute("src", url)
    document.body.appendChild(iframe)
    iframe.parentNode.removeChild(iframe)
    iframe = null
    handled = true
  }
  else if (window[ANDROID_JS_API]) {
    window[ANDROID_JS_API].onControlEvent(event, param1, param2, param3)
    handled = true
  }
  return handled
}

function set_idle (idle) {
  player.root.toggleClass("is-idle", idle)
}

function toggle_error (toggle, error) {
  var container = flowplayer.mq("fp-error-container")
  if (container) container.remove()

  if (!toggle) return

  container = flowplayer.mq.div("fp-error-container")
  var text = flowplayer.mq.div("fp-error-text").txt(error)
  var btn =  flowplayer.mq.div("fp-reload-button")

  btn.on("click", reload)

  container.append(text)
  container.append(btn)
  player.root.append(container)
  
}

function parse_json (str) {
  try {
    return JSON.parse(str)
  } catch {
    return {}
  }
}

// Native event handler called from Android native
window.onPlayerEvent = function(event, value, detail) {
  log("onPlayerEvent", event, value)
  if (!player) return
  
  switch (event) {
    case PlayerEvents.IDLE: {
      player.paused = true
      player.ended = false
      toggle_error (false)
      break
    }
    case PlayerEvents.LOADING: {
      player.emit(flowplayer.events.LOAD_START)
      player.emit(flowplayer.events.WAITING)
      break
    } 
    case PlayerEvents.PREPARED: {
      player.emit(flowplayer.events.METADATA)
      player.emit(flowplayer.events.DATA)
      player.emit(flowplayer.events.CAN_PLAY)
      player.paused = true
      player.emit(flowplayer.events.PAUSE)
      player.root.toggleClass("is-loading", false)
      player.root.toggleClass("is-loaded", true)
      player.root.toggleClass("is-starting", false)
      break
    } 
    case PlayerEvents.BUFFERING: { 
      player.emit(flowplayer.events.WAITING); 
      break 
    }
    case PlayerEvents.PLAYING: {
      player.paused = false
      player.ended = false
      player.emit(flowplayer.events.PLAYING)
      break
    } 
    case PlayerEvents.PAUSED: {
      player.paused = true
      player.ended = false
      player.emit(flowplayer.events.PAUSE)
      break
    } 
    case PlayerEvents.DURATION: {
      var duration = parseInt(value)
      if (!isNaN(duration)) {
        player.duration = value
        player.emit(flowplayer.events.DURATION_CHANGE)
      }
      break
    }
    case PlayerEvents.PROGRESS: {
      var progress = parseInt(value)
      if (!isNaN(progress)) {
        player.proxy_values["currentTime"] = progress
        player.emit(flowplayer.events.TIME_UPDATE)
      }
      break
    }
    case PlayerEvents.COMPLETED: {
      player.paused = true
      player.ended = true
      player.emit(flowplayer.events.ENDED)
      break
    }
    case PlayerEvents.FULLSCREEN: {
      var newValue = (value === "true")
      player.toggleFullScreen(newValue, true)
      player.root.toggleClass("is-fullscreen", newValue)
      player.emit(flowplayer.events.RESIZE)
      break
    }
    case PlayerEvents.MUTED: {
      var mute = (value === "true")
      if (player.muted !== mute) {
        player.muted = mute
      }
      break
    }
    case PlayerEvents.VOLUME: {
      var volume = parseFloat(value)
      if (!isNaN(volume)) {
        player.proxy_values["volume"] = volume
        player.emit(flowplayer.events.VOLUME_CHANGE)
      }
      break
    }
    case PlayerEvents.PLAYBACK_RATE: {
      var rate = parseFloat(value)
      if (!isNaN(rate)) {
        player.proxy_values["playbackRate"] = rate
      }
      break
    }
    case PlayerEvents.QUALITIES: {
      var qualities = parse_json(value)
      if (qualities instanceof Array) {
        player.emit(flowplayer.events.QUALITIES, qualities)
      }
      break
    }
    case PlayerEvents.SET_QUALITY: {
      var level = parseInt(value)
      if (!isNaN(rate)) {
        player.emit(flowplayer.events.QUALITIES, qualities)
      }
      break
    }
    case PlayerEvents.AUDIO_TRACKS: {
      var tracks = parse_json(value)
      if (tracks instanceof Array) {
        player.emit("audio:tracks", tracks)
      }
      break
    }
    case PlayerEvents.SUBTITLE_TRACKS: {
      var tracks = parse_json(value)
      if (tracks instanceof Array) {
        player.textTracks = tracks.map(function(t) { return Object.assign({ kind: "subtitles", label: t.name }, t) })
        player.emit("tracks:text:all", player.textTracks)
      }
      break
    }
    case PlayerEvents.CAST_STATE_CHANGED: {
      var state = parse_json(value)
      if (!state) return player.emit("chromecast:session:changed", { sessionState: "SESSION_ENDED" })
      
      player.emit("chromecast:field:update", {
        field: "mediaInfo",
        value: {
          fake_session: {
            device_name: function() { return "Chromecast" },
            state: function() { return "playing" },
            hide_controls: true
          }
        }
      })
    }
    case PlayerEvents.OVP_METADATA: {
      var metadata = parse_json(value)
      player.setOpts({
        metadata
      })
      break
    }
    case PlayerEvents.SET_AUDIO: {
      var track = parse_json(value)
      if (track instanceof Object) {
        player.emit("audio:update", track)
      }
      break
    }
    case PlayerEvents.SET_SUBTITLE: {
      var track = parse_json(value)
      if (!Object.keys.length(track)) track = { id: value }
      if (track instanceof Object) {
        player.emit("tracks:text:updated", track)
      }
    }
    case PlayerEvents.ERROR: {
      log("Error event:", value, detail)
      toggle_error (true, detail)
      break
    }
    
    default:
      log("Unrecognized player event", event)
  }

  set_idle(event === PlayerEvents.IDLE)
}
